import { createSlice } from '@reduxjs/toolkit';

const initialCalculationTO2State = {
  listLoading: false,
  actionsLoading: false,
  saveCalcLoading: false,
  lastError: null,
  attachId: [],
  saveCalculationNum: null,
  saveResponseType: '',
  entities: [],
  userSavedEntitiesIds: [],
  errorsList: null,
  responseType: '',
};
export const callTypes = {
  list: 'list',
  action: 'action',
  saveCalc: 'save',
};

export const calculationTO2Slice = createSlice({
  name: 'calculationTO2',
  initialState: initialCalculationTO2State,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
        return;
      }
      if (action.payload.callType === callTypes.action) {
        state.actionsLoading = false;
        return;
      }
      if (action.payload.callType === callTypes.saveCalc) {
        state.saveCalcLoading = false;
        state.saveResponseType = 'failure';
        return;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.attachId = null;
      state.saveCalculationNum = null;
      state.saveResponseType = '';

      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
        return;
      }
      if (action.payload.callType === callTypes.action) {
        state.actionsLoading = true;
        return;
      }
      if (action.payload.callType === callTypes.saveCalc) {
        state.saveCalcLoading = true;
        return;
      }
    },

    calculationTO2Fetched: (state, action) => {
      const { data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.userSavedEntitiesIds = initialCalculationTO2State.userSavedEntitiesIds;

      if (data.type === 'success') {
        state.entities = [...data.entities];
        state.responseType = data.type;
        return;
      }

      if (data.type === 'warning') {
        state.entities = [];
        state.responseType = data.type;

        state.errorsList = data.warning;
        return;
      }

      if (data.type === 'error') {
        state.entities = [];
        state.responseType = data.type;
        state.errorsList = { ...data.error };
        return;
      }

      if (data.type === 'empty') {
        state.entities = [];
        state.responseType = data.type;
        state.errorsList = null;
        return;
      }
    },

    saveCalculationTO2Fetched: (state, action) => {
      const { data } = action.payload;
      state.saveCalcLoading = false;
      state.error = null;

      if (data.type === 'success') {
        state.attachId = [...data.aid];
        state.saveResponseType = data.type;
        state.saveCalculationNum = data.request;
        return;
      }
    },

    clearSaveResponseType: state => {
      state.saveResponseType = '';
      return;
    },

    saveSavedCalcId: (state, action) => {
      state.userSavedEntitiesIds = [...state.userSavedEntitiesIds, action.payload.id];
    },
  },
});
